import React from 'react';
import { NavLink, Link } from 'react-router-dom';
import { useT } from '../i18n';
import LanguagePopover from './LanguagePopover';
import './PublicNav.css';

// ── THE HEADER A SIGNED-OUT VISITOR GETS ON THE PUBLIC PAGES ─────────────────
// /designers, /shop, /search, /designer/:uid, /shop/:uid and /product/:id all
// share one header, and every control in its right-hand side is signed-in only:
// HeaderSearch, NotificationBell and MessagesButton each return null without a
// user. What was left for a visitor was the logo and a "Sign in" link with
// forty ems of nothing between them — no way to reach the shop from the
// directory, no way to get home, and no language control on a site that ships
// in three languages.
//
// THE SAME PIECES AS THE LANDING NAV, deliberately. A visitor arrives on these
// pages FROM the homepage, so a header that suddenly drops its navigation reads
// as a different site. Same links, same order, same language gear.
//
// NOT A COPY OF LANDING'S MARKUP, though: that nav is styled by `.landing`'s
// own token block (brass on near-black) and lives inside its scroll container.
// This one uses the `--site-*` tokens like the rest of the app, so it follows
// the light/dark theme the way every other page header does.
const LINKS = [
  { to: '/', k: 'nav_home', end: true },
  { to: '/designers', k: 'nav_designers' },
  { to: '/shop', k: 'nav_marketplace' },
];

export default function PublicNav() {
  const { t } = useT();

  const links = LINKS.map(n => (
    <NavLink
      key={n.to}
      to={n.to}
      end={n.end}
      className={({ isActive }) => `pnv-link${isActive ? ' pnv-link--on' : ''}`}
    >{t(n.k)}</NavLink>
  ));

  return (
    <>
      {/* DESKTOP ONLY. Below 760px this row plus two buttons and the gear is
          more than the bar has width for — the same trade the landing makes at
          900px, where its longer link labels run out of room sooner. The links
          are not dropped on a phone, they move into the gear's menu below. */}
      <nav className="pnv-links" aria-label={t('nav_primary')}>{links}</nav>

      <Link to="/login" className="pnv-signin">{t('nav_login')}</Link>
      <Link to="/register" className="pnv-signup">{t('lnd_signup')}</Link>

      {/* LanguagePopover renders whatever it is given ABOVE the language pills
          and closes itself when one is followed — it was built for exactly this
          on the landing. Passing children also swaps its icon from a gear to
          three lines, which is honest: it is a menu here, not just settings. */}
      <LanguagePopover triggerClassName="pnv-gear">
        <div className="lgp-nav">
          <div className="lgp-label">{t('nav_primary')}</div>
          {LINKS.map(n => (
            <NavLink
              key={n.to}
              to={n.to}
              end={n.end}
              className={({ isActive }) => `lgp-nav-link${isActive ? ' lgp-nav-link--on' : ''}`}
            >{t(n.k)}</NavLink>
          ))}
        </div>
      </LanguagePopover>
    </>
  );
}
